import { render, staticRenderFns } from "./FilterSaveModal.vue?vue&type=template&id=20edd681&scoped=true"
import script from "./FilterSaveModal.vue?vue&type=script&lang=js"
export * from "./FilterSaveModal.vue?vue&type=script&lang=js"
import style0 from "./FilterSaveModal.vue?vue&type=style&index=0&id=20edd681&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20edd681",
  null
  
)

export default component.exports